/**
 * CalculateListContainer
 * --
 */
import React from 'react';
import { useUserStack } from 'store';
import CalculateList from 'routes/admin.routes/admin.calculate/CalculateList';

/**----------------------------------------
 * [Component] 쇼핑몰관리자: 정산목록 컨테이너
 * ----------------------------------------
 */
const CalculateListContainer = () => {
  /* ===== ROUTE ===== */
  const userInfo = useUserStack();
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      {userInfo && (
        <CalculateList
          permission={userInfo.type}
          defaultShopId={userInfo.shop_information_id}
        />
      )}
    </>
  );
};

export default CalculateListContainer;
